import axios from "axios";
import {set, get } from "lodash";
import Vue from "vue";

import store from "../store/userStore";
import userService from "./services/userService";
import VueCookies from 'vue-cookies';
import constants from "../utils/constants";
import router from "../router";
Vue.use(VueCookies, { expire: '30d'})

const instance = axios.create({
    baseURL: constants.IS_REWISE ? '/' : process.env.VUE_APP_API_URL_OMR
});

const UNAUTHORIZED_ERROR_CODES = ["ERR401", "ERR419"];
const SKIP_ERROR_TOAST = ["ERR008", "ERR049","ERR0115","ERR0107","ERR0151","ERR0157","ERR0158"];


instance.interceptors.response.use(response => {
    handleError(response);

    return response;
}, function(error) {
    // Do something with response error

    handleError(error.response)
    return Promise.reject(error.response);
});

function handleError(response) {
    let unauthorized;
    let isShowErrorMsg = JSON.parse(VueCookies.get('isShowErrorMsg',constants.COOKIE_PATH,constants.COOKEI_DOMAIN));
    let token = getToken()

    if (response.data && response.data.errors && response.data.errors.length) {
        console.log({'requestFileHandleErrorMethod' : response.data.errors});
        let errors = response.data.errors;
        for (let i = 0; i < errors.length; i++) {

            if (SKIP_ERROR_TOAST.indexOf(errors[i].code) < 0) {
                if (!isShowErrorMsg) {
                    
                    Vue.toasted.error(errors[i].message, { icon: 'info' });
                }
            }

            if (UNAUTHORIZED_ERROR_CODES.indexOf(errors[i].code) >= 0) {
                unauthorized = true;
            }
        }
    }
	const user= JSON.parse(sessionStorage.getItem('user'))
    const myInstitute = JSON.parse(localStorage.getItem('myInstitute'));
    let institute = get(store, "state.myInstitute");
    if (response.status === 401 || unauthorized) {
        console.log("request file",{'response' : response, 'response.status': response.status, 'unauthorized': unauthorized,'session auth_token':response.config.headers.Authorization,'url':response.config.url});
        sessionStorage.clear();
        localStorage.removeItem('user')
        localStorage.removeItem('auth_token')
		user && sessionStorage.setItem('oldRoleId',user.role_id);
        VueCookies.remove('keepMeLoggedIn',constants.COOKIE_PATH,constants.COOKEI_DOMAIN);
        VueCookies.remove('isShowErrorMsg',constants.COOKIE_PATH,constants.COOKEI_DOMAIN);
        VueCookies.remove('upgrade',constants.COOKIE_PATH,constants.COOKEI_DOMAIN);
        if (!isShowErrorMsg && institute.id === constants.ONLINE_INSTITUTE_ID && (user.role_id === constants.ROLES_ID.ST || user.role_id === constants.ROLES_ID.PA) ) {
            window.location.href = constants.IS_REWISE ? constants.REWISE_REDIRECT_URL : process.env.VUE_APP_REDIRECT_LOGIN_URL;
        }
        // window.onbeforeunload = null; // need in case of 2 tabs are opened by student adn logs in again when test is active.
        if (constants.CUSTOM_INSTITUTE_ID.includes(myInstitute.id)) {
            router.push({name: "customized-tests-myt"}).catch(()=>{})
            store.mutations.logOut(store.state);
        }else{
            router.push({name: "login"});
        }
    }
}
function getToken(){
    let userTokenCookie = VueCookies.get('userDetails');
    userTokenCookie = userTokenCookie && userTokenCookie.userToken ? JSON.parse(userTokenCookie.userToken):"";
    let token = get(store, "state.token");
    if (userTokenCookie && token !== userTokenCookie) {
        token = userTokenCookie
    }
    return token
  }
export default instance;